const normalizeDateValue = (value) => {
  if (!value) return null;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  parsed.setHours(0, 0, 0, 0);
  return parsed;
};

export const isPlayerRegistrationOpen = (value) =>
  String(value ?? "").trim().toLowerCase() === "open";

export const isVolunteerRegistrationOpen = (event) => {
  if (typeof event?.volunteer_registration_open === "boolean") {
    return event.volunteer_registration_open;
  }

  if (isPlayerRegistrationOpen(event?.registration)) {
    return true;
  }

  const start =
    normalizeDateValue(event?.date || event?.event_date || null);
  if (!start) return false;

  const end =
    normalizeDateValue(event?.event_end_date || event?.end_date || event?.date || event?.event_date || null) ||
    start;
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return today >= start && today <= end;
};

export const getVolunteerRegistrationLabel = (event) => {
  if (!isVolunteerRegistrationOpen(event)) {
    return "Closed";
  }

  return isPlayerRegistrationOpen(event?.registration)
    ? "Open for volunteers"
    : "Open during ongoing event";
};
